
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1611452084144",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "18462",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M982.912686 11.008633A34.367979 34.367979 0 0 0 957.696701 0.00064H66.305259A34.239979 34.239979 0 0 0 32.00128 36.864617l68.671957 853.311467a34.239979 34.239979 0 0 0 25.151984 30.207981l377.151765 102.399936a34.623978 34.623978 0 0 0 18.047988 0l377.151765-102.399936a34.175979 34.175979 0 0 0 25.151984-30.207981L992.00068 36.864617a34.047979 34.047979 0 0 0-9.087994-25.855984z m-179.199888 279.167826H327.233095l9.791994 136.511914h453.055717l-23.551985 327.871795L512.00098 839.040116l-257.151839-85.311947V597.312267h102.847935v82.559948l154.303904 51.199968 156.863902-52.095967 10.751993-149.951907H241.281149l-24.511984-341.311786h586.687633z",
        "p-id": "18463"
      }
    }
  ]
})
    }
  